import ExternalApiKeySec from './components/ExternalApiKeySec';
import InternalApiKeySec from './components/InternalApiKeySec';
import useProfile from '../../../hooks/useProfile';
import ProfileForm from '../../../components/ProfileForm';
import HeadshotUploadForm from '../../../components/HeadshotUploadForm';
import useHeadshot from '../../../hooks/useHeadshot';
import useCertifiedLifecareCompany from '../../../hooks/useCertifiedLifecareCompany';
import ProfileFormActionButton from '../../../components/ProfileFormActionButton';
import { CurriculumVitae, SignatureUploadSection } from './components';
import { RECORD_DATA_TYPE } from '@demandproai/shared';

const Profile = () => {
  const { formik: profileFormik } = useProfile();
  const {
    formik: headshotFormik,
    isLoading: isHeadshotLoading,
    isUploading,
    handleFileSelection
  } = useHeadshot();

  const isCertifiedLifecareCompany = useCertifiedLifecareCompany();

  const handleSaveAll = async () => {
    const profileErrors = await profileFormik.validateForm();
    if (Object.keys(profileErrors).length > 0) return;
    await Promise.all([
      profileFormik.submitForm(),
      isCertifiedLifecareCompany ? headshotFormik.submitForm() : Promise.resolve()
    ]);
  };

  return (
    <>
      <div className="wrapper px-5">
        <div className="content">
          <div className="relative flex flex-col min-w-0 break-words bg-surface mb-12! shadow-[0_0_20px_rgba(16,24,40,0.15)] rounded-[calc(var(--spacing)*2.5)] px-5 py-[calc(var(--spacing)*7.5)]">
            <div className="p-0! mb-12!">
              <div className="row">
                <ProfileForm
                  formik={profileFormik}
                  resetPasswordPath="/forgot-password"
                />
                <HeadshotUploadForm
                  formik={headshotFormik}
                  handleFileSelection={handleFileSelection}
                  isUploading={isUploading}
                />
              </div>
            </div>
            <ProfileFormActionButton
              cancelPath="/cases"
              onSave={handleSaveAll}
              disabled={isHeadshotLoading || isUploading || profileFormik.isSubmitting}
            />
          </div>
          {isCertifiedLifecareCompany && <CurriculumVitae  recordType={RECORD_DATA_TYPE.CURRICULUM_VITAE} />}
          {isCertifiedLifecareCompany && <SignatureUploadSection />}
          <ExternalApiKeySec /> {/* For Partners */}
          <InternalApiKeySec /> {/* For IFame */}
        </div>
      </div >
    </>

  )
}

export default Profile;
